import React from 'react';

const ErrorPages = () => {
    return (
        <div className="grid justify-center items-center h-screen lg:text-5xl md:text-3xl text-2xl">
            
            <h1>404 || Page Not Found</h1>
        </div>
    );
};

export default ErrorPages;